export enum SourceOfFeesOptions {
    billRate = 'Bill rate',
    payRate = 'Pay rate',
}

export const sourceOfFeesOptions = [SourceOfFeesOptions.billRate, SourceOfFeesOptions.payRate];
